import {InfoEnregistrement} from './infoEnregistrement';
export class Conjoint {
    id:any=null;
	  agent_im="";
	  agent_type:any="";
	  agent_im_autre="";
	  agent_nom="";
	  agent_prenom="";
	  agent_date_naissance ="";
	  agent_dateNaissance="";
	  agent_sexe="";
	  agent_situation="";	
	  agent_adresse="";
	  agent_email="";
	  agent_tel="";
	  agent_fonction="";
	  agent_cin="";
	  agent_datePS=Date;
	  agent_service="";
agent_parent_id :number = null;
agent_conjoint_id : number = null; 
agent_direction="";
agent_departement="";
	  agent_lieu_travail="";
	  agent_porte="";
	  agent_nom_conjoin="";
	  agent_prenom_conjoin="";
	  agent_num_ate_mariage="";
	  agent_nobre_enfant=null;
	   agent_nom_enfant="";
	  agent_grade="";
	  agent_indice="";
	  agent_allergie="";
	  agent_antecedent="";
	  agent_maladie_chronique="";
	  agent_etat="";
	  agent_lieu_naissance="";
	  agent_tel1="";
	  agent_tel2="";
	  photo="";
	  agent_url_photo="";
	  agent_photo64="";
	  age : number =null;
	  conjoint : Conjoint;
	  date_debut ="";
	  date_fin ="";
	  conjoint_agent_ministere =false;
	  montant_total="";
	  infoEnregistrement : InfoEnregistrement=new InfoEnregistrement();
   constructor($id:any){
            this.id=$id;           
        } 
}
